module.exports = __webpack_public_path__ + "static/media/6D.93a9b3e8.svg";